import script from "./AppStoreInstallSelectionPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreInstallSelectionPopup.vue?vue&type=script&setup=true&lang=ts"

import "./AppStoreInstallSelectionPopup.vue?vue&type=style&index=0&id=0d1f417e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1f417e"]])

export default __exports__